module.exports = __webpack_public_path__ + "img/sweden-external-causes-female.0b14282b.png";